import { getCurrencyIcon, makeFloat, useGetShortBalance } from 'react-easyrocket';
import { THREE_SECONDS } from 'src/constants';

export const useGetBalance = () => {
  const { data, isLoading } = useGetShortBalance({
    refetchInterval: THREE_SECONDS,
    target: 'refetchBalance'
  });

  const fsBalance = makeFloat(data?.bonusFreespins ?? 0);
  const balance = makeFloat(data?.balance ?? 0);
  const currencyIcon = getCurrencyIcon(data?.currency);

  return {
    shortBalance: data,
    isLoading,
    balance,
    fsBalance,
    currencyIcon,
    iconWithBalance: `${currencyIcon} ${balance}`
  };
};
